module.exports = __webpack_public_path__ + "img/image159.c0572fba.jpg";